var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component",attrs:{"id":"app"}},[_c('router-view'),_c('toast-alert'),_c('portal-target',{attrs:{"name":"modals"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }